define('_views/Contact',[
	'text!_templates/contact.html'
],
function(
	contactTemplate
) {

	/**
	 * https://github.com/scottgonzalez/sane-email-validation
	 */
	
	var localAddr = /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+$/i;
	var domain = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

	function isEmail( str ) {
		var parts = str.split( "@" );
		if ( parts.length !== 2 ) {
			return false;
		}

		if ( !localAddr.test( parts[ 0 ] ) ) {
			return false;
		}

		if ( !domain.test( parts[ 1 ] ) ) {
			return false;
		}

		return true;
	}

	return Backbone.View.extend({

		template: _.template(contactTemplate),

		events : {
			'click #send-new-message'		: 'sendNewMessage',
			'click #close_panel'			: 'closeBackstage',
			'click [data-cancel-message]'	: 'cancelMessage',
			'click .focus-field'			: 'focusNearestField',
			'focusin textarea'			: 'adjustForMobile'
		},

		initialize: function(){

			var _this = this;

			Backstage.Events.on('slidepanel:open_complete', function(e){
				if(Backbone.history.fragment == "contact") {
					if(!_this.isMobile) {_this.focusFirstField();}
					_this.bindKeyEvents();
					_this.$el.removeClass('hidden').show();
				}
			});

			Backstage.Events.on('slidepanel:close_complete', function(e){
				if(Backbone.history.getFragment() == "contact") {
					_this.resetContactForm();
				}
			});
			
		},

		validators: {
			'not-empty': function(element){
				return element.value.length > 0;
			},
			'email': function(element){
				return isEmail(element.value);
			}
		},

		preventDefault: function(e) {
			e.preventDefault();
		},

		/**
		 *	Test for iOS.
		 *  
		 *  @memberof Cargo.o.Helpers
		 *  @return {boolean}
		 *  @example Cargo.Helper.isIOS();
		 */
		isIOS : function() {
			if (navigator.userAgent.match(/i(Phone|Pod|Pad)/i)) {
				return true;	
			} else {
				return false;
			}
		},

		isMobile : function() {
			if(this.isIOS()) return true
			else {
				var check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
				return check;
			}
		},


		validateInput: function(element){

			var isValid = true,
				_this = this,
				validators = element.getAttribute('data-validate');

			if(validators == null) {
				return false;
			}

			_.each(validators.toLowerCase().split(' '), function(validator){

				if(this.validators[validator](element) === false) {
					isValid = false;
				}

			}, this);

			if(isValid === false) {
				$(element).one('input', function(){
					_this.validateInput(element);
				});

				$(element).closest('[data-input-parent]').addClass('invalid');

			} else if($(element).closest('[data-input-parent]').hasClass('invalid')) {
				$(element).closest('[data-input-parent]').removeClass('invalid');
			}

			return isValid;

		},

		bindKeyEvents: function(e) {
			_this = this;
			$(document.body).on('keyup.contact_form', _.bind(function(e){
				if (e.which == 27) {
					e.preventDefault();
					e.stopImmediatePropagation();
					_this.closeBackstage();
				}
			}, this));
		},

		validateForm: function(){

			var allValid = true,
				inputs = [],
				_this = this;

			this.$el.find('[data-validate]').each(function(index, el){

				var isValid = _this.validateInput(el);

				if(isValid === false) {
					allValid = false;
				}

				inputs.push({
					el: el,
					valid: isValid
				});

			});	

			return {
				valid: allValid,
				inputs: inputs
			};

		},

		render: function(e) {

			this.$el.html(
				this.template({
					defaults : this.model.toJSON(),
					isMobile : this.isMobile(),
				})
			);
			
			return this;

		},

		growMessageField: function() {

			var text = document.getElementById('new-message');

			setTimeout(function(){
				text.focus();
			text.select();
				text.style.height = 'auto';
				text.style.height = text.scrollHeight+'px';
			}, 1)

		},

		resetContactForm: function() {
			$(document.body).off('keyup.contact_form');
			$('#processing .message').hide();
			this.render();
			this.$el.addClass('hidden');
			Backstage.Router.navigate('spotlight', true);
		},

		sendNewMessage: function(e) {

			this.processingButton(true);

			var validate = this.validateForm();
			
			if(validate.valid !== true) {
				this.processingButton(false);
				return false;
			}

			var data = {
				from : $('input[name="sender"]', this.el).val(),
				site_id : Backstage.Model.Default.get('id'),
				message : $('#new-message', this.el).val()
			};

			var _this = this;

			$.post('/dispatch/notifications/sendContactMessage', data, function(data) {
				if(data.error.length > 0) {
					// stop loading animation					
					_this.processingButton(false);
					// throw alert
					parent.window.Cargo.Modal.Alert({
						message: data.error[0],
						selector: 'html'
					});

				} else {
					// fade out the form
					_this.$el.fadeOut();
					// show large loading animation
					$('#processing').show();
					$('#processing .loading_animation').fadeIn(400);

					// show the pulse, and sent message
					setTimeout(function(){
						$('#processing .message').show();
						$('#processing .loading_animation').hide();

						setTimeout(function(){
							_this.closeBackstage();
						}, 1500)

					}, 1500)

				}

			}, 'json');
			
		},

		processingButton: function(state){
			if (state == true) {
				this.$el.find('#send-new-message .processing .loading_animation').removeClass('hidden');
			} else {
				this.$el.find('#send-new-message .processing .loading_animation').addClass('hidden');
			}	
		},

		closeSlidePanel: function() {
			Backstage.Events.trigger('slidepanel:close');
		},

		closeBackstage: function() {
			Backstage.View.Main.closeBackstage();
		},

		cancelMessage: function() {
			Backstage.View.Main.closeBackstage();
			this.$el.find('#new-message').val('');
		},

		focusFirstField: function() {
			if (this.$el.find('input').val() == '') {
				this.$el.find('input').focus();
			} else {
				this.$el.find('textarea').focus();
			}
			
		},

		focusNearestField: function(e) {
			var input = $(e.target).closest('[data-input-parent]').find('input');
			input.focus().val(input.val());

		},

		focusEmailField: function(e) {

			var email = this.model.toJSON().cookie_email;

			if(e.type == 'focusin' && $(e.target).val() == email) {

				$(e.target).val('').focus();
				
			} else if (e.type == 'focusout' && ($(e.target).val() == '' || $(e.target).val() == email)) {
				$(e.target).val(email);

			}
		},

		adjustForMobile: function(e) {
			e.preventDefault();

			var	fh1 = parseInt($('[data-to-address]').outerHeight(true)),
				fh2 = parseInt($('[data-from-address]').outerHeight(true)),
				new_height = fh1 + fh2;

			if (this.isMobile()) {
				var parentbody = parent.document.body;
				parentbody.scrollTop = new_height;
			}
		},

	});

});



